@if (!isLoading) {
  <app-filter
    id="filterMenu"
    [isOpen]="filterMenuOpen"
    [filters]="filters"
    [data]="data"
    (filterMenuOpenChange)="filterMenuOpen = $event"
    (filteredData)="onFilteredData($event)"
    (filterChange)="onFiltersChange($event)"></app-filter>
}
@if (activeFilterChips.length > 0) {
  <div class="active-filter-chips">
    @for (chip of activeFilterChips; track $index) {
      <div class="active-filter-chip">
        <span class="active-filter-chip-label">{{ chip.label }}</span>
        <button
          type="button"
          class="active-filter-chip-remove"
          (click)="removeFilterChip(chip)"
          aria-label="Filter entfernen">
          <i class="fa-regular fa-times"></i>
        </button>
      </div>
    }
  </div>
}
<div class="table-container" [style.border-color]="borderColor">
  <div
    class="table-header"
    [style.background-color]="headerColor"
    [style.border-color]="borderColor">
    <div class="table-title">
      <span class="title">
        {{ getTableTitle(searchedAndFilteredData?.length) }}
      </span>
    </div>
    <div class="table-actions">
      <div class="table-search">
        <input
          type="text"
          name="table-search"
          placeholder="Hier suchen..."
          [(ngModel)]="searchQuery"
          (input)="applySearch()" />
      </div>
      @if (filters && filters.length > 0) {
        <button
          id="filterMenuButton"
          [ngStyle]="{ '--hover-color': borderColor }"
          class="inwi-icon-text-button-medium-outline"
          (click)="filterMenuOpen = !filterMenuOpen">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-filter"></i>
            </div>
            <div class="button-text">Filter</div>
          </div>
        </button>
      }
      @if (tableHeaderButton) {
        <button
          class="inwi-icon-text-button-medium-outline"
          (click)="tableHeaderButton.onClick()">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular" [class]="tableHeaderButton.icon"></i>
            </div>
            <div class="button-text">{{ tableHeaderButton.label }}</div>
          </div>
        </button>
      }
      @if (tableHeaderDropdownMenu) {
        <button
          class="inwi-text-icon-button-medium-outline"
          (click)="
            optionMenu.toggle($event);
            tableHeaderDropdownMenu.visible = !tableHeaderDropdownMenu.visible
          ">
          <div class="button-content">
            <div class="button-text">Kontakt erstellen</div>
            <div class="button-icon">
              @if (tableHeaderDropdownMenu.visible) {
                <i class="fa-regular fa-chevron-up"></i>
              } @else {
                <i class="fa-regular fa-chevron-down"></i>
              }
            </div>
          </div>
        </button>
        <p-menu
          #optionMenu
          [model]="tableHeaderDropdownMenu.options"
          [popup]="true">
        </p-menu>
      }
    </div>
  </div>

  <!-- Table -->
  <div class="table-wrapper">
    <table class="custom-table">
      @if (paginatedData?.length > 0) {
        <thead>
          <tr class="custom-table-colums-header">
            @for (column of columns; track $index) {
              <th
                (click)="onSort(column)"
                [style.width]="getColumnWidth(column)"
                [style.textAlign]="column.headerAlign || 'left'"
                [style.cursor]="column.sortable ? 'pointer' : 'default'">
                {{ column.header }}
                <!-- Sorting direction indicators -->
                @if (sortedColumn === column) {
                  @if (sortDirection === 'asc') {
                    <i class="fa-regular fa-arrow-down-short-wide"></i>
                  }
                  @if (sortDirection === 'desc') {
                    <i class="fa-regular fa-arrow-up-wide-short"></i>
                  }
                } @else if (column.sortable && sortedColumn !== column) {
                  <i class="fa-regular fa-arrow-up-arrow-down"></i>
                }
              </th>
            }
          </tr>
        </thead>
      }
      <tbody>
        @if (isLoading) {
          @for (item of [].constructor(pageSize); track $index) {
            <tr class="custom-table-row">
              @for (column of columns; track $index) {
                <td>
                  <p-skeleton styleClass="mb-2" borderRadius="16px" />
                </td>
              }
            </tr>
          }
        } @else {
          @if (!data || data.length === 0) {
            <tr>
              <td [attr.colspan]="columns.length">
                <div class="no-data">
                  @if (noDataIcon) {
                    <i class="fa-regular {{ noDataIcon }}"></i>
                  }
                  <span class="no-data-message">
                    {{ noDataMessage }}
                  </span>
                </div>
              </td>
            </tr>
          } @else if (filteredData.length === 0) {
            <tr>
              <td [attr.colspan]="columns.length">
                <div class="no-data">
                  @if (noSearchResultsIcon) {
                    <i class="fa-regular {{ noSearchResultsIcon }}"></i>
                  }
                  <span class="no-data-message">
                    {{ noSearchResultsMessage }}
                  </span>
                </div>
              </td>
            </tr>
          }

          @for (row of paginatedData; track $index) {
            <tr class="custom-table-row cursor-pointer">
              @for (column of columns; track $index) {
                <td
                  [style.font-weight]="column.fontWeight ?? '600'"
                  [style.textAlign]="column.cellAlign || 'left'"
                  [style.place-items]="
                    column.cellAlign === 'center' ? 'center' : 'start'
                  "
                  (click)="
                    column.onCellClick ? column.onCellClick(row, column) : null
                  "
                  pTooltip="{{
                    column.tooltip ? column.tooltip(row)?.tooltipText : ''
                  }}"
                  [tooltipPosition]="
                    column.tooltip ? column.tooltip(row)?.position : 'top'
                  "
                  [autoHide]="
                    column.tooltip ? column.tooltip(row)?.autoHide : true
                  "
                  [tooltipDisabled]="!column.tooltip">
                  <!-- Render logic: if the column has a render function, use it -->
                  @if (column.avatarUser) {
                    <div class="user-table-container">
                      <app-avatar
                        class="img"
                        size="x-small"
                        [user]="column.avatarUser(row)">
                      </app-avatar>
                      <span>{{
                        getTableNameValue(column.avatarUser(row))
                      }}</span>
                    </div>
                  } @else if (column.render) {
                    @if (column.render(row) !== null) {
                      <div
                        [ngClass]="{
                          'custom-cell-center': column.cellAlign === 'center',
                          'custom-cell-right': column.cellAlign === 'right',
                        }"
                        [innerHTML]="column.render(row) | sanitizeHtml"></div>
                    } @else {
                      <div class="flex-r justify-center">--</div>
                    }
                  } @else if (row[column.columnDef]) {
                    {{ row[column.columnDef] }}
                  } @else {
                    <div class="flex-r justify-center">--</div>
                  }
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
  <div class="paginator">
    <div class="current-page">
      <span>Seite: {{ currentPage }}</span>
    </div>
    <div class="pagination">
      <button
        type="button"
        class="paginator-navigation"
        (click)="prev()"
        [disabled]="isFirstPage()">
        <div class="button-icon">
          <i class="fa-regular fa-chevron-left"></i>
        </div>
        <div class="button-text">Zurück</div>
      </button>
      <app-custom-select
        [options]="pageSizeSelectOptions"
        [selectedOption]="pageSize"
        (valueChange)="changePageSize($event)">
      </app-custom-select>
      <button
        type="button"
        class="paginator-navigation"
        (click)="next()"
        [disabled]="isLastPage()">
        <div class="button-text">Nächste</div>
        <div class="button-icon">
          <i class="fa-regular fa-chevron-right"></i>
        </div>
      </button>
    </div>
  </div>
</div>
